import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { MenuIcon } from '@/components/Organizer/OrganizerShell/orgMenuIcons'
import { DASHBOARD_TOUR } from './definitions/dashboard.tour'

/**
 * The small card at the top right of the page offering the page's guided tour (useTourInvite; kit:
 * white panel, hairline, radius 10, soft floating shadow, ink text, no primary button — the page keeps
 * its own). « See the guide » plays it, « Not now » hides it for the session, « Don't show again for this
 * page » for good. Escape = « Not now ». Portaled to <body>: a fixed card inside a transformed ancestor
 * would scroll with the page.
 */
export default function TourInvite({ def, onAccept, onLater, onNever }) {
    const { t } = useTranslation(TranslationNS.TOURS)
    const dashboard = def?.id === DASHBOARD_TOUR.id

    useEffect(() => {
        const onKey = (event) => {
            if (event.key !== 'Escape' || event.defaultPrevented) return
            onLater()
        }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [onLater])

    if (!def) return null

    return createPortal(
        <div className="sf-invite" role="region" aria-labelledby="sfInviteTtl" data-tour-invite={def.id}>
            <div className="sf-invite-head">
                <MenuIcon name="help" />
                <p className="sf-invite-ttl" id="sfInviteTtl">
                    {dashboard ? t('Discover your dashboard?') : t('Discover this page?')}
                </p>
            </div>
            <p className="sf-invite-txt">
                {dashboard
                    ? t('A one-minute guided tour walks you through the organizer menu.')
                    : t('A one-minute guided tour shows you what each part of this page is for.')}
            </p>
            <div className="sf-invite-acts">
                <button type="button" className="sf-invite-btn" onClick={onAccept}>
                    {t('See the guide')}
                </button>
                <button type="button" className="sf-invite-link" onClick={onLater}>
                    {t('Not now')}
                </button>
            </div>
            <button type="button" className="sf-invite-link sf-invite-never" onClick={onNever}>
                {dashboard ? t("Don't show again") : t("Don't show again for this page")}
            </button>
        </div>,
        document.body,
    )
}
